import React from 'react';
import { withRouter } from 'react-router-dom';

import Storage from '../helpers/Storage';
import { sendRequest, triggerEvent } from '../helpers/global.js';

import TextInput from './input/TextInput.js';

import '../sass/components/LoginView.scss';

const SIGN_UP_LINK = 'https://business.burpple.com/claim_business';

class LoginView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: {
        email: '',
        password: '',
      },
      errors: {},
    };
  }

  componentDidMount = () => {
    triggerEvent('logAmplitude', 'login - start');
  }

  loginAction = (data) => {
    localStorage.setItem('burpple-md-admin:token', data.access_token);
    Storage.setData('user', data.user);
    triggerEvent('logAmplitude', 'login - complete');
  }

  handleSubmit = () => {
    let data = this.state.data;
    let errors = {};
    if (!data.email) {
      errors.email = 'Please enter Email';
    }
    if (!data.password) {
      errors.password = 'Please enter Password';
    }
    if (Object.keys(errors).length > 0) {
      this.setState({errors});
      return;
    }
    sendRequest({
      method: 'auth/login',
      auth: true,
      type: 'POST',
      data: {
        email: data.email,
        password: data.password,
        app: 'merchant_dashboard',
        user_agent: window.navigator.userAgent,
      },
      success: (data) => {
        if (data.access_token) {
          this.loginAction(data);
        }
      },
      error: (data) => {
        if (data?.errors) {
          if (data.errors === 403) {
            triggerEvent('showSnackbar', [{text: 'Your Account is not yet Approved', type: 'error'}]);
          } else {
            if (data.errors.email === 'not_found') {
              data.errors.email = <>
                Sorry we couldn't find an account with that email.&nbsp;
                <span onClick={() => window.open(SIGN_UP_LINK, '_blank')}>Sign up</span> instead
              </>
            }
            this.setState({errors: data.errors});
          }
        }
      }
    });
  }

  renderInput = (key, title, type = 'text') => {
    return (
      <div key={key}>
        <label htmlFor={key}>{title}</label>
        <TextInput
          properties={{type}}
          objectKey={key}
          object={this.state.data[key] || ''}
          onChange={(k, val) => this.setState({data: {...this.state.data, [key]: val}})}
          onFocus={() => this.setState({errors: {...this.state.errors, [key]: null}})}
          error={this.state.errors[key]}
        />
      </div>
    )
  }

  render = () => {
    return (
      <div className='loginView'>
        <div className='loginForm'>
          <div className='logo'/>
          <div className='loginTitle'>Welcome to your dashboard</div>
          <div className='loginSubtitle'>Log in to your account</div>
          {this.renderInput('email', 'Email', 'email')}
          {this.renderInput('password', 'Password', 'password')}
          <button
            onClick={this.handleSubmit}
          >Login</button>
          <div className='bottomRow'>
            Don’t have a business account?
            <span
              onClick={() => window.open(SIGN_UP_LINK, '_blank')}
            >Sign up</span>
          </div>
          <div className='bottomRow'>
            <span
              onClick={() => this.props.history.push('/forgot_password')}
            >Forgot password?</span>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(LoginView);
